<template>
  <div class="home">
    <HomeScreen />
  </div>
</template>

<script>
import HomeScreen from "@/components/HomeScreen.vue";

export default {
  name: "Home",
  components: {
    HomeScreen
  }
};
</script>
